import { render, staticRenderFns } from "./RegionResultEntry.vue?vue&type=template&id=f7f9f0f0&scoped=true"
import script from "./RegionResultEntry.vue?vue&type=script&lang=js"
export * from "./RegionResultEntry.vue?vue&type=script&lang=js"
import style0 from "./RegionResultEntry.vue?vue&type=style&index=0&id=f7f9f0f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7f9f0f0",
  null
  
)

export default component.exports